import { Component, OnInit, Input } from '@angular/core';
import { ProspectService } from 'src/app/services/prospect.service';
import { FormChangeService } from 'src/app/services/form-change.service';
import { AlertService } from 'src/app/services/alert-service.service';
import { Router } from '@angular/router';
import { NgModel } from '@angular/forms';
import { RangesFooter } from './ranges-footer/ranges-footer.component';
import { SatDatepickerRangeValue } from 'saturn-datepicker';
import * as moment from 'moment';

@Component({
  selector: 'app-form-min-prospect',
  templateUrl: './form-min-prospect.component.html',
  styleUrls: ['./form-min-prospect.component.scss']
})
export class FormMinProspectComponent implements OnInit {
  rangesFooter = RangesFooter;
  dateRange: SatDatepickerRangeValue<Date>;
  sites: {};
  selectedCustomer: string;
  prospects;
  selectedSite: any[];

  selectAll: boolean;
  searchText: string;
  searchTextCust: string;
  newSearched = true;
  numeroMin: number;
  numeroMax: number;
  model: NgModel;
  countAnnonces;
  @Input() withPeriod: boolean;
  period: any;
  selectedPeriod: string;
  periodList: any[];
  constructor(
    private alertService: AlertService,
    private prospectSer: ProspectService,
    private formService: FormChangeService,
    public router: Router) {
  }


  ngOnInit() {
    this.rechercher();
    this.subscribeReloadSearchRequest();
  }

  subscribeReloadSearchRequest() {
    this.formService.reloadProspectRequest.subscribe(
      () => {
        this.rechercher();
      });
  }
  // efface le formulaire de rechercher appelé depuis navBar
  clearForm() {
    this.rechercher();
  }
  private findTextInProspect(prospects) {
    let filter = this.getTextFilter();
    let prospectFiltred = prospects;
    if (filter) {
      let text = filter.split(' ');
      prospectFiltred = prospects.filter(function (item) {
        let flt = text.every(function (el) {
          let tmp = (item['companyName'] && item['companyName'].toUpperCase().indexOf(el.toUpperCase()) > -1)
            || (item['contactTel'] && item['contactTel'].toUpperCase().indexOf(el.toUpperCase()) > -1)
            || (item['contactMail'] && item['contactMail'].toUpperCase().indexOf(el.toUpperCase()) > -1);
            return tmp;
        });

        return flt;
      });

    }
    prospectFiltred = this.filterPrspectDateRange(prospectFiltred);
    return prospectFiltred;
  }
  filterPrspectDateRange(prospectFiltred: Array<any>): any {
    let tmp = prospectFiltred;
    if(this.dateRange){
      let start = moment(this.dateRange.begin).startOf('day');
      let end = moment(this.dateRange.end).startOf('day');
      tmp = tmp.filter(element => {
        let nextContact = element.nextContact?moment(element.nextContact): null;
        return nextContact && nextContact.startOf('day').isBetween(start,end,undefined,'[]');
      });

    }
    return tmp;
  }

  private getTextFilter() {
    return this.searchText;
  }

rechercher() {
    this.getProspectsFromBackEnd()
      .subscribe(
        (data) => {
          let tmpUsers = data as Array<any>;
           tmpUsers = this.findTextInProspect(tmpUsers);
          this.formService.raiseProspectListEvent(tmpUsers);
        }
        , (error) => {
          console.log(error);
          this.formService.raiseProspectListEvent([]);
        });
  }

  onFormChange() {
    this.rechercher();
  }

  getProspectsFromBackEnd() {
    return this.prospectSer.getProspects();
  }

}
